<template>
    <div class="accordion-content py-3 pl-3" ref="accordionContent">
        <div class="accordion-header flex" @click="onClick">
            <div class="flex-grow font-semibold">{{ title }} <Popover v-if="info != ''" :text="info" style-filled="true"></Popover>
                <div v-if="subtitle" class="subtitle" :class="{'subtitle-small': subtitleSmall}">{{ subtitle }}</div>
            </div>
            <div class="accordion-toggle w-6 h-6 m-0 p-0 text-center">
                <Checkbox v-if="showCheckbox" :checked="isOpen"></Checkbox>
                <span v-else :class="isOpen ? 'icon-minus' : 'icon-plus'"></span>
            </div>
        </div>
        <div v-show="isOpen && !stayClosed" class="mt-3 pr-3">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import Popover from './Popover.vue';
import { mapFields } from 'vuex-map-fields';
import Checkbox from "~/scripts/Components/Checkbox.vue";

export default {
    components: {
        Popover,
        Checkbox
    },
    props: {
        title: String,
        showCheckbox: {
            type: Boolean,
            default: false
        },
        subtitle: String,
        info: {
            type: String,
            default: ''
        },
        open: {
            type: Boolean,
            default: false
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        navigateStep: {
            type: Boolean,
            default: false
        },
        stayClosed: {
            type: Boolean,
            default: false
        },
        subtitleSmall: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapFields({
            step: 'step'
        })
    },
    data() {
        return {
            isOpen: this.open
        }
    },
    methods: {
        onClick() {
            if (!this.isDisabled) {
                this.$emit('click');
                this.isOpen = !this.isOpen;
            }
        },
        navigateToSubstep() {
            this.$nextTick(() => {
                const controlPanel = document.querySelector('.control-panel');
                const currentStepContainer = document.querySelector(`.step-container.step-${this.step}`);
                if (controlPanel) {
                    controlPanel.scrollTo({
                        top: currentStepContainer.offsetTop + this.$refs.accordionContent.offsetTop - 4,
                        behavior: 'smooth'
                    });
                }
            });
        }
    },
    watch: {
        open() {
            this.isOpen = this.open;
            if (this.isOpen) {
                this.navigateToSubstep();
            }
        },

        navigateStep() {
            if (this.navigateStep) {
                this.navigateToSubstep();
            }
        }
    }
}
</script>
